import { APP_NAME, APP_VERSION, APP_COMMIT_SHORT, APP_CHANNEL, DEVELOPER } from './appInfo';

/**
 * Modal "Informazioni": app, versione e riferimenti dello sviluppatore.
 * Aperto dal click sul footer del DashboardLayout. I link esterni si aprono
 * in una nuova scheda (nel wrapper RN la navigazione top-level e' intercettata
 * da M4 e aperta nel browser/app di sistema, la PWA resta intatta).
 */
export function AboutModal({ onClose }: { onClose: () => void }): React.JSX.Element {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: 420, textAlign: 'center' }}>
        <img src="/icon-128.webp" alt="" style={{ width: 72, height: 72, borderRadius: 14, margin: '6px auto 10px' }} />
        <h3 style={{ margin: '0 0 2px' }}>{APP_NAME}</h3>
        <div style={{ color: '#888', fontSize: 13, marginBottom: 14 }}>
          v{APP_VERSION}
          {APP_CHANNEL !== 'release' && APP_CHANNEL !== 'local' && (
            <span style={{ marginLeft: 6, fontSize: 11, color: '#aaa' }}>({APP_CHANNEL})</span>
          )}
          <div style={{ fontSize: 11, color: '#bbb', marginTop: 2 }}>build {APP_COMMIT_SHORT}</div>
        </div>

        <p style={{ fontSize: 14, color: '#555', marginBottom: 18 }}>
          Tracciamento interventi, selettive, mezzi, magazzino e idranti
          per i Distaccamenti Volontari VVF.
        </p>

        <div style={{ borderTop: '1px solid #eee', paddingTop: 14, marginBottom: 16 }}>
          <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 2 }}>{DEVELOPER.name}</div>
          <div style={{ fontSize: 13, color: '#666', marginBottom: 10 }}>
            {DEVELOPER.owner} · {DEVELOPER.ownerRole}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6, fontSize: 14 }}>
            <a href={DEVELOPER.website} target="_blank" rel="noreferrer" style={{ color: '#1e40af', textDecoration: 'none' }}>
              🌐 gsolutions-it.com
            </a>
            <a href={`mailto:${DEVELOPER.email}`} style={{ color: '#1e40af', textDecoration: 'none' }}>
              ✉️ {DEVELOPER.email}
            </a>
            <a href={`tel:${DEVELOPER.phone.replace(/\s/g, '')}`} style={{ color: '#1e40af', textDecoration: 'none' }}>
              📞 {DEVELOPER.phone}
            </a>
          </div>
          <div style={{ fontSize: 11, color: '#999', marginTop: 12 }}>
            {DEVELOPER.legalName} · P.IVA {DEVELOPER.vatNumber} · {DEVELOPER.city}
          </div>
          <div style={{ fontSize: 12, color: '#888', fontStyle: 'italic', marginTop: 6 }}>
            "{DEVELOPER.tagline}"
          </div>
        </div>

        <button onClick={onClose} className="btn-secondary"
          style={{ width: '100%', padding: 10, fontWeight: 600 }}>
          Chiudi
        </button>
      </div>
    </div>
  );
}
